<template>
    <div>
        <pdf-viewer v-if="downloadKey" :class="viewerclass" :url="urlWithKey"></pdf-viewer>
        <div v-else class="spinner-border text-dark" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
    import { reportsApiService } from '@/services/reports-api.service.js'
    import PdfViewer from '@/components/pdf-viewer/PdfViewer.vue'

    export default {
        name: 'pdfViewerWithKey',
        props: {
            viewerurl: String,
            viewerclass: String
        },
        components: {
            PdfViewer,
        },
        data: () => ({
            downloadKey: null,            
        }),
        mounted () {
            this.getKey()
        },
        methods: {
            getKey() {
                
                reportsApiService.getDownloadKey()
                    .then(response => {
                        this.downloadKey = response.data
                    })
                    .catch(error => {
                        
                        return null
                    })
            }
        },
        computed: {
            urlWithKey() {
                return  this.viewerurl + '/' + this.downloadKey
            }
        }
    }
</script>

    